var React = require('react');

function GoogleLive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z","key":1})]);
}

GoogleLive.defaultProps = {"viewBox":"0 0 24 24","fill":"#00893f","width":"24px","height":"24px"};

module.exports = GoogleLive;

GoogleLive.default = GoogleLive;
